import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const KakaoColors = createInteractiveColorVars('kakao');
const KakaoColorsLightValues = Object.freeze({
    base: {
        default: '#FEE500',
        action: '#ebd402',
        active: '#FEE500',
        activeAction: '#ebd402',
    },
    text: {
        default: '#262200',
        action: '#262200',
        active: '#262200',
        activeAction: '#262200',
    },
});
const KakaoColorsDarkValues = Object.freeze({
    base: {
        default: '#FEE500',
        action: '#ebd402',
        active: '#FEE500',
        activeAction: '#ebd402',
    },
    text: {
        default: '#262200',
        action: '#262200',
        active: '#262200',
        activeAction: '#262200',
    },
});

export { KakaoColors, KakaoColorsDarkValues, KakaoColorsLightValues };
